import { Heading, HStack, Image, Table, Text, VStack } from "@chakra-ui/react";

import { GoonAvatar } from "@/components/goon-avatar";
import { RoundedButton } from "@/components/rounded-button";
import {
  DialogBody,
  DialogContent,
  DialogHeader,
  DialogRoot,
  DialogTrigger,
} from "@/components/ui/dialog";
import { RafflePrize } from "@/hooks/useRaffle";
import { getImgPathFromPrizeId } from "@/utils";

type WinnersProps = { rafflePrize: RafflePrize };

export const Winners = ({ rafflePrize }: WinnersProps) => {
  const winners = rafflePrize.winners;
  if (!winners || winners.length === 0) return null;
  if (winners.length === 1)
    return <GoonAvatar seed={winners[0].winnerAddress} boxSize={5} />;
  return <WinnersModal rafflePrize={rafflePrize} />;
};

const WinnersModal = ({ rafflePrize }: { rafflePrize: RafflePrize }) => {
  return (
    <DialogRoot size="md">
      <DialogTrigger asChild>
        <HStack>
          <Heading size="md" fontWeight="500">
            {rafflePrize?.winners?.length}
          </Heading>
          <RoundedButton
            color="fg"
            variant="subtle"
            h="24px"
            w="60px"
            fontSize="12px"
          >
            View All
          </RoundedButton>
        </HStack>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <HStack gap={4}>
            <Image
              src={getImgPathFromPrizeId(rafflePrize.id)}
              boxSize={16}
              rounded="xl"
            />
            <VStack alignItems="left" gap={0}>
              <Heading fontSize="2xl">Winners of</Heading>
              <Heading color="fg.muted" fontSize="lg">
                {rafflePrize.name}
              </Heading>
            </VStack>
          </HStack>
        </DialogHeader>
        <DialogBody>
          <Table.Root
            borderCollapse="separate"
            fontWeight="500"
            fontFamily="Inter, sans-serif"
            fontSize="md"
          >
            <Table.Header>
              <Table.Row fontSize="sm" bg="transparent">
                <Table.ColumnHeader borderBottom="none" color="fg.muted" pl={0}>
                  Winner
                </Table.ColumnHeader>
                <Table.ColumnHeader borderBottom="none" color="fg.muted" pl={0}>
                  Picked On
                </Table.ColumnHeader>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {rafflePrize.winners?.map((winner) => (
                <Table.Row key={winner.winnerAddress}>
                  <Table.Cell borderBottom="none" p={0}>
                    <GoonAvatar
                      seed={winner.winnerAddress}
                      withAddress
                      boxSize={5}
                    />
                  </Table.Cell>
                  <Table.Cell borderBottom="none" p={0}>
                    <Text>{rafflePrize.endsAt?.toLocaleDateString()}</Text>
                  </Table.Cell>
                </Table.Row>
              ))}
            </Table.Body>
          </Table.Root>
        </DialogBody>
      </DialogContent>
    </DialogRoot>
  );
};
